import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var Register = /*#__PURE__*/function () {
  function Register() {
    _classCallCheck(this, Register);
    _defineProperty(this, "data", {});
  }
  _createClass(Register, [{
    key: "get",
    value: function get(name, defaultValue) {
      if (name in this.data) {
        return this.data[name];
      } else {
        return this.set(name, defaultValue);
      }
    }
  }, {
    key: "set",
    value: function set(name, value) {
      this.data[name] = value;
      return this.data[name];
    }
  }]);
  return Register;
}();
export { Register };
export default new Register();
//# sourceMappingURL=register.mjs.map